import { render, staticRenderFns } from "./tenMinutesMatching.vue?vue&type=template&id=66386163"
import script from "./tenMinutesMatching.vue?vue&type=script&lang=js"
export * from "./tenMinutesMatching.vue?vue&type=script&lang=js"
import style0 from "./tenMinutesMatching.vue?vue&type=style&index=0&id=66386163&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports